export const webUrls = {
    marketPlace: "http://3.139.69.64/",
    affiliate: "http://18.191.212.109/",
    partnerCenter: "https://86kitchensellercenter.netlify.app/",
    superAdmin: "https://86kitchenadmin.netlify.app/dashboard",
}